export function headerSearch() {
    const openSearchBtn = document.querySelector('.open-search-button');
    const headerSearch = document.querySelector('.header-search');

    if (openSearchBtn) {
        openSearchBtn.addEventListener('click', function () {
            headerSearch.classList.toggle('search-active');
            this.classList.toggle('active');
            document.body.classList.remove('menu-opened');
            document.querySelector('.btn-menu').classList.remove('open');
        });
    }

    //new search
    const body = document.body;
    const toggleSearchBtn = document.querySelector('.header-search-toggle');
    if(!toggleSearchBtn) return;
    const headerSearchHolder = document.querySelector('.header-search-holder');
    const headerMenuInner = document.querySelector('.header-menu-inner');
    const input = headerSearchHolder.querySelector('input');
    const toggleSpan = toggleSearchBtn.querySelector('span');

    const closeSearch = () => {
        headerSearchHolder.classList.remove('active');
        setTimeout(() => body.classList.remove('search-active'), 300);
        input.value = '';
        toggleSpan.textContent = 'Search';
    };

    const openSearch = () => {
        headerSearchHolder.classList.add('active');
        body.classList.add('search-active');
        setTimeout(() => input.focus(), 100);
        toggleSearchBtn.classList.remove('active');
        toggleSpan.textContent = 'Cancel';
    };

    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!headerMenuInner.contains(target) && headerSearchHolder.classList.contains('active')) {
            closeSearch();
        }
    });

    toggleSearchBtn.addEventListener('click', () => {
        body.classList.contains('search-active') ? closeSearch() : openSearch();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSearch.js